import React from 'react';
import { Fit, LongText, Text, fs } from '../parts/fields';
import { Logo, useFieldSize } from '../parts/chrome';
import { str, useSlide } from '../parts/context';
import { fill } from '../text';

// #region CtaLayout
/** The close, on the brand gradient: one ask and one button (the rep's booking link unless the slide sets its own). */
export const CtaLayout: React.FunctionComponent = (): React.ReactElement => {
    const { slide, context, mode, edit, onSelectField, onAction } = useSlide();
    const size = useFieldSize('title', [[30, 112], [56, 96], [999, 80]]);
    const own = str(slide.fields.button_url).trim();
    const url = /^https:\/\//.test(own) ? own : context.values['rep.booking_link'] || '';
    const label = fill(str(slide.fields.button_label) || 'Book a call', context.values, mode);
    const contact = [context.values['rep.name'], context.values['rep.email'], context.values['rep.phone']].filter((x) => x && x.trim());
    return (
        <>
            <div aria-hidden="true" style={{ position: 'absolute', inset: 0, background: 'var(--wd-frame)' }} />
            <div aria-hidden="true" style={{ position: 'absolute', width: 1500, height: 1500, left: -500, bottom: -1000, borderRadius: '50%', border: '3px solid rgba(255,255,255,.14)' }} />
            <div aria-hidden="true" style={{ position: 'absolute', width: 900, height: 900, right: -300, top: -420, borderRadius: '50%', background: 'rgba(255,255,255,.07)' }} />
            <div className="wd-pad wd-on-dark" style={{ alignItems: 'center', textAlign: 'center' }}>
                <Fit style={{ flex: 1, width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                    <Text k="title" as="h2" className="wd-h" style={{ fontSize: fs(size), maxWidth: 1420 }} placeholder="The ask" max={90} />
                    <LongText k="body" className="wd-lead" style={{ fontSize: fs(34), marginTop: 40, maxWidth: 1120 }} placeholder="One or two lines (optional)" max={300} />
                    <div style={{ marginTop: 72 }}>
                        {edit ? (
                            <span className="wd-button" style={{ background: '#fff', color: 'var(--wd-accent)' }} onClick={(e) => { e.stopPropagation(); onSelectField?.('button_url'); }}>
                                <Text k="button_label" as="span" placeholder="Book a call" max={30} />
                                <Arrow />
                            </span>
                        ) : url ? (
                            <a className="wd-button" href={url} target="_blank" rel="noopener noreferrer" onClick={() => onAction?.('cta', url)} style={{ background: '#fff', color: 'var(--wd-accent)' }}>
                                {label}<Arrow />
                            </a>
                        ) : (
                            <span className="wd-button" style={{ background: '#fff', color: 'var(--wd-accent)' }}>{label}</span>
                        )}
                    </div>
                    {contact.length ? <p style={{ marginTop: 44, fontSize: fs(26), color: 'rgba(255,255,255,.82)' }}>{contact.join('  ·  ')}</p> : null}
                    {edit && !url ? <p style={{ marginTop: 16, fontSize: 20, color: 'rgba(255,255,255,.7)' }} onClick={() => onSelectField?.('button_url')}>No booking link on the rep’s profile: set a button link.</p> : null}
                </Fit>
            </div>
            <Logo dark style={{ left: '50%', transform: 'translateX(-50%)' }} />
        </>
    );
};

const Arrow: React.FunctionComponent = (): React.ReactElement => (
    <svg viewBox="0 0 24 24" width="34" height="34" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" /></svg>
);
